import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule } from '@angular/forms';
import { SharedModule } from 'app/shared/shared.module';
import { UIModule } from 'app/ui/ui.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { EditorModule } from '@tinymce/tinymce-angular';
import { MediaModule } from 'app/media/media.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ModalEditContentComponent } from './modal-edit-content/modal-edit-content.component';
import { TutorialModule } from 'app/tutorial/tutorial.module';
import { IntegrationModule } from 'app/integration/integration.module';
import { CalendarModule } from 'primeng/calendar';
import { LinkyModule } from 'ngx-linky';
import { ColorPickerModule } from 'primeng/colorpicker';
import { RouterModule } from '@angular/router';

import { ModalSelectProductComponent, ModalEditProductDirective } from './modal-select-product/modal-select-product.component';
import { ProductResultsComponent } from './product-search/product-results/product-results.component';
import { ModalEditLabourCategoryComponent } from './modal-edit-labour-category/modal-edit-labour-category.component';
import { ModalEditSubscriptionCategoryComponent } from './modal-edit-subscription-category/modal-edit-subscription-category.component';
import { ModalSelectEntityComponent } from './modal-select-entity/modal-select-entity.component';
import { ModalEditProductTypeComponent } from './modal-edit-product-type/modal-edit-product-type.component';
import { ModalEditCategoryGroupComponent } from './modal-edit-category-group/modal-edit-category-group.component';
import { ModalEditCategoryComponent } from './modal-edit-category/modal-edit-category.component';
import { ModalEditLabourComponent } from './modal-edit-labour/modal-edit-labour.component';
import { ModalEditPricingStructureComponent } from './modal-edit-pricing-structure/modal-edit-pricing-structure.component';
import { ModalEditSubscriptionComponent } from './modal-edit-subscription/modal-edit-subscription.component';
import { ModalEditUnitComponent } from './modal-edit-unit/modal-edit-unit.component';
import { ModalEditEntityDirective, ModalEditEntityComponent } from './modal-edit-entity/modal-edit-entity.component';
import { ModalAddCategoryFromPresetsComponent } from './modal-add-category-from-presets/modal-add-category-from-presets.component';
import { ModalEditProjectComponent } from './modal-edit-project/modal-edit-project.component';
import { ModalProjectPortalAccessComponent } from './modal-project-portal-access/modal-project-portal-access.component';
import { ModalPortalPreviewComponent } from './modal-portal-preview/modal-portal-preview.component';
import { ModalProjectManagePortalQuotesComponent } from './modal-project-manage-portal-quotes/modal-project-manage-portal-quotes.component';
import { ModalProjectCoverImageComponent } from './modal-project-cover-image/modal-project-cover-image.component';
import { ModalQuoteSelectLinesByProductComponent } from './modal-quote-select-lines-by-product/modal-quote-select-lines-by-product.component';
import { ModalAddPortalProjectComponent } from './modal-add-portal-project/modal-add-portal-project.component';
import { ModalSelectQuoteComponent } from './modal-select-quote/modal-select-quote.component';
import { ModalCrmQuoteDealsComponent } from './modal-crm-quote-deals/modal-crm-quote-deals.component';
import { ModalEditCustomerComponent } from './modal-edit-customer/modal-edit-customer.component';
import { ModalEditCustomerContactComponent } from './modal-edit-customer-contact/modal-edit-customer-contact.component';
import { ModalSelectCustomerComponent } from './modal-select-customer/modal-select-customer.component';
import { ModalLinkSupplierToAccountsComponent } from './modal-link-supplier-to-accounts/modal-link-supplier-to-accounts.component';
import { ModalActivityLogComponent } from './modal-activity-log/modal-activity-log.component';
import { ModalEditBundleCounterComponent } from './modal-edit-bundle-counter/modal-edit-bundle-counter.component';
import { ModalEditBundleQuestionComponent } from './modal-edit-bundle-question/modal-edit-bundle-question.component';
import { ModalCloneProductComponent } from './modal-clone-product/modal-clone-product.component';
import { ModalEditProductComponent } from './modal-edit-product/modal-edit-product.component';
import { ModalFileImporterComponent } from './modal-file-importer/modal-file-importer.component';
import { ModalCustomiseSidebarComponent } from './modal-customise-sidebar/modal-customise-sidebar.component';
import { ModalCrmPipelineComponent } from './modal-crm-pipeline/modal-crm-pipeline.component';
import { ModalCrmSourceContactComponent } from './modal-crm-source-contact/modal-crm-source-contact.component';
import { CrmSourceContactPickerComponent } from './modal-crm-source-contact/crm-source-contact-picker.component';
import { ModalCrmSourceComponent } from './modal-crm-source/modal-crm-source.component';
import { CrmSourcePickerComponent } from './modal-crm-source/crm-source-picker.component';
import { CrmSearchSelectComponent } from './crm-search-select/crm-search-select.component';
import { ModalReorderCategoryGroupsComponent } from './modal-reorder-category-groups/modal-reorder-category-groups.component';
import { ModalProjectExportComponent } from './modal-project-exporter/modal-project-exporter.component';
import { ModalQuoteChooseProjectComponent } from './modal-quote-choose-project/modal-quote-choose-project.component';
import { ModalEditPaymentOptionComponent } from './modal-edit-payment-option/modal-edit-payment-option.component';
import { ModalEditPaymentStageComponent } from './modal-edit-payment-stage/modal-edit-payment-stage.component';
import { ModalEditPaymentStageSetupComponent } from './modal-edit-payment-stage-setup/modal-edit-payment-stage-setup.component';
import { ModalAddPaymentStagesComponent } from './modal-add-payment-stages/modal-add-payment-stages.component';
import { KeywordsPipe } from 'app/shared/keywords.pipe';
import { ModalSelectPaymentOptionComponent } from './modal-select-payment-option/modal-select-payment-option.component';
import { ModalEditProductCategoryGroupComponent } from './modal-edit-product-category-group/modal-edit-product-category-group.component';
import { ModalEditProductCategoryComponent } from './modal-edit-product-category/modal-edit-product-category.component';
import { ModalReorderProductCategoryGroupsComponent } from './modal-reorder-product-category-groups/modal-reorder-product-category-groups.component';
import { ModalEditProductCounterComponent } from './modal-edit-product-counter/modal-edit-product-counter.component';
import { ModalEditProductCounterGroupComponent } from './modal-edit-product-counter-group/modal-edit-product-counter-group.component';
import { ModalEditSnagComponent } from './modal-edit-snag/modal-edit-snag.component';
import { ModalSelectSnagComponent } from './modal-select-snag/modal-select-snag.component';
import { ModalEditProjectTimesheetComponent } from './modal-edit-project-timesheet/modal-edit-project-timesheet.component';
import { ModalEditContactDeliveryAddressComponent } from './modal-edit-contact-delivery-address/modal-edit-contact-delivery-address.component';
import { ModalGlobalSearchComponent } from './modal-global-search/modal-global-search.component';
import { ProductDetailComponent } from './modal-global-search/product-detail/product-detail.component';
import { ModalEditOptionLibraryComponent } from './modal-edit-option-library/modal-edit-option-library.component';
import { ModalSelectIconComponent } from './modal-select-icon/modal-select-icon.component';
import { ModalAlertPopupComponent } from './modal-alert-popup/modal-alert-popup.component';
import { ModalCsvImporterComponent } from './modal-csv-importer/modal-csv-importer.component';
import { ModalHelpFormulaComponent } from './modal-help-formula/modal-help-formula.component';
import { ModalEditLabelComponent } from './modal-edit-label/modal-edit-label.component';
import { ModalCrmLeadComponent } from './modal-crm-lead/modal-crm-lead.component';
import { ModalCrmDealComponent } from './modal-crm-deal/modal-crm-deal.component';
import { ModalCrmStageComponent } from './modal-crm-stage/modal-crm-stage.component';
import { ModalSettingsInvoiceTermsComponent } from './modal-settings-invoice-terms/modal-settings-invoice-terms.component';
import { ModalSalesDetailsComponent } from './modal-sales-details/modal-sales-details.component';
import { ModalEditTaskComponent } from './modal-edit-task/modal-edit-task.component';
import { ModalTaskDetailsComponent } from './modal-task-details/modal-task-details.component';
import { ModalEditPhaseComponent } from './modal-edit-phase/modal-edit-phase.component';
import { ModalSelectProjectComponent } from './modal-select-project/modal-select-project.component';
import { ModalBillingUpgradeAccountComponent } from './modal-billing-upgrade-account/modal-billing-upgrade-account.component';
import { ModalEditDependencyComponent } from './modal-edit-dependency/modal-edit-dependency.component';
import { ModalCreateTaskMultiComponent } from './modal-create-task-multi/modal-create-task-multi.component';
import { ModalWorkOrderTaskListComponent } from './modal-work-order-task-list/modal-work-order-task-list.component';
import { ModalEditUserComponent } from './modal-edit-user/modal-edit-user.component';
import { ModalSelectWorkOrderComponent } from './modal-select-work-order/modal-select-work-order.component';
import { ModalSelectCatalogueCountryComponent } from './modal-select-catalogue-country/modal-select-catalogue-country.component';
import { ModalCreateManualWorkOrderComponent } from './modal-create-manual-work-order/modal-create-manual-work-order.component';
import { ModalProjectInvoiceComponent } from './modal-project-invoice/modal-project-invoice.component';
import { ModalProjectAddToInvoiceComponent } from './modal-project-add-to-invoice/modal-project-add-to-invoice.component';
import { ModalProjectAssignAdditionalProductsComponent } from './modal-project-assign-additional-products/modal-project-assign-additional-products.component';
import { ModalProjectConfirmSalesOrderComponent } from './modal-project-confirm-sales-order/modal-project-confirm-sales-order.component';
import { ModalProjectRemoveFromInvoiceComponent } from './modal-project-remove-from-invoice/modal-project-remove-from-invoice.component';
import { ModalProjectInvoicedItemsComponent } from './modal-project-invoiced-items/modal-project-invoiced-items.component';
import { ModalProjectInvoiceAllocateComponent } from './modal-project-invoice-allocate/modal-project-invoice-allocate.component';
import { ModalEditProjectNotesComponent } from './modal-edit-project-notes/modal-edit-project-notes.component';
import { ModalContactQuotesProjectsListComponent } from './modal-contact-quotes-projects-list/modal-contact-quotes-projects-list.component';
import { ModalEditDocumentComponent } from './modal-edit-document/modal-edit-document.component';
import { ModalProjectPasswordListComponent } from './modal-project-password-list/modal-project-password-list.component';
import { ModalQuickbooksDesktopActionsComponent } from './modal-quickbooks-desktop-actions/modal-quickbooks-desktop-actions.component';
import { ModalBulkEditTaskComponent } from './modal-bulk-edit-task/modal-bulk-edit-task.component';
import { ModalCrmWinComponent } from './modal-crm-win/modal-crm-win.component';
import { ModalCrmLoseComponent } from './modal-crm-lose/modal-crm-lose.component';
import { ModalCrmDiscardComponent } from './modal-crm-discard/modal-crm-discard.component';
import { ModalQuoteAcceptComponent } from './modal-quote-accept/modal-quote-accept.component';
import { ModalQuoteMarkAsSentComponent } from './modal-quote-mark-as-sent/modal-quote-mark-as-sent.component';
import { ModalEditCustomisableHeaderFieldComponent } from './modal-edit-customisable-header-field/modal-edit-customisable-header-field.component';
import { ModalEditUserContactComponent } from './modal-edit-user-contact/modal-edit-user-contact.component';
import { ModalTimesheetExportComponent } from './modal-timesheet-exporter/modal-timesheet-exporter.component';
import { ModalTimesheetEditConflictComponent } from './modal-timesheet-edit-conflict/modal-timesheet-edit-conflict.component';
import { ModalTimesheetApprovalsComponent } from './modal-timesheet-approvals/modal-timesheet-approvals.component';
import { ModalListProjectClockedinTimeComponent } from './modal-list-project-clockedin-time/modal-list-project-clockedin-time.component';
import { ModalViewDependencyComponent } from './modal-view-dependency/modal-view-dependency.component';
import { ModalTimesheetAddEntryComponent } from './modal-timesheet-add-entry/modal-timesheet-add-entry.component';
import { ModalSelectTaskComponent } from './modal-select-task/modal-select-task.component';
import { ModalSelectTimezoneComponent } from './modal-select-timezone/modal-select-timezone.component';
import { ModalListScheduleCalendarComponent } from './modal-list-schedule-calendar/modal-list-schedule-calendar.component';
import { ModalEditScheduleCalendarComponent } from './modal-edit-schedule-calendar/modal-edit-schedule-calendar.component';
import { ModalProjectInvoiceAssignmentsComponent } from './modal-project-invoice-assignments/modal-project-invoice-assignments.component';
import { ModalEditWorkOrderComponent } from './modal-edit-work-order/modal-edit-work-order.component';
import { ModalWorkOrderNotesComponent } from './modal-work-order-notes/modal-work-order-notes.component';
import { ModalWorkOrderContactsComponent } from './modal-work-order-contacts/modal-work-order-contacts.component';
import { ModalWorkOrderAssignedUsersComponent } from './modal-work-order-assigned-users/modal-work-order-assigned-users.component';
import { ModalCustomerDocumentsComponent } from './modal-customer-documents/modal-customer-documents.component';
import { ModalWorkOrderTimelineComponent } from './modal-work-order-timeline/modal-work-order-timeline.component';
import { ModalWorkOrderReportsComponent } from './modal-work-order-reports/modal-work-order-reports.component';
import { ModalEditReportComponent } from './modal-edit-report/modal-edit-report.component';
import { ModalEditDependencyOutcomeComponent } from './modal-edit-dependency-outcome/modal-edit-dependency-outcome.component';
import { AngularResizeEventModule } from 'angular-resize-event';
import { ModalTaskNotesComponent } from './modal-task-notes/modal-task-notes.component';
import { ModalEditTutorialCategoryComponent } from './modal-edit-tutorial-category/modal-edit-tutorial-category.component';
import { ModalEditTaskFollowupComponent } from './modal-edit-task-followup/modal-edit-task-followup.component';
import { ModalWorkOrderDependencyComponent } from './modal-work-order-dependency/modal-work-order-dependency.component';
import { LocalizedDatePipe } from 'app/shared/localized-date.pipe';
import { ModalBulkEditSnaggComponent } from './modal-bulk-edit-snagg/modal-bulk-edit-snagg.component';
import { ModalGenerateSnaggsReportComponent } from './modal-generate-snaggs-report/modal-generate-snaggs-report.component';
import { ModalBulkEditDependencyComponent } from './modal-bulk-edit-dependency/modal-bulk-edit-dependency.component';
import { ModalGenerateDependencyReportComponent } from './modal-generate-dependency-report/modal-generate-dependency-report.component';
import { ModalEditAllocationComponent } from './modal-edit-allocation/modal-edit-allocation.component';
import { ModalWorkOrderBookingHistoryComponent } from './modal-work-order-booking-history/modal-work-order-booking-history.component';
import { ModalCatalogueSyncLogComponent } from './modal-catalogue-sync-log/modal-catalogue-sync-log.component';
import { ModalPurchaseReviewReassignRequestComponent } from './modal-purchase-review-reassign-request/modal-purchase-review-reassign-request.component';
import { ModalPurchaseChangeRequestSourceComponent } from './modal-purchase-change-request-source/modal-purchase-change-request-source.component';
import { ModalTrackPOComponent } from './modal-track-request/modal-track-po.component';
import { ModalAddAdditionalProductsComponent } from './modal-add-additional-products/modal-add-additional-products.component';
import { ModalProductDetailsComponent } from './modal-product-details/modal-product-details.component';
import { ModalAddWarehouseComponent } from './modal-add-warehouse/modal-add-warehouse.component';
import { ModalAddProductToPOComponent } from './modal-add-product-to-po/modal-add-product-to-po.component';
import { ModalEditWarehouseReserveItemsComponent } from './modal-edit-warehouse-reserve-items/modal-edit-warehouse-reserve-items.component';
import { ModalEditWarehouseAdjustQuantityComponent } from './modal-edit-warehouse-adjust-quantity/modal-edit-warehouse-adjust-quantity.component';
import { ModalEditWarehouseReorderDetailsComponent } from './modal-edit-warehouse-reorder-details/modal-edit-warehouse-reorder-details.component';
import { ModalEditWarehouseUnitCostComponent } from './modal-edit-warehouse-unit-cost/modal-edit-warehouse-unit-cost.component';
import { ModalListWarehouseRequestedItemsComponent } from './modal-list-warehouse-requested-items/modal-list-warehouse-requested-items.component';
import { ModalEditWarehouseReservedStockComponent } from './modal-edit-warehouse-reserved-stock/modal-edit-warehouse-reserved-stock.component';
import { ModalEditWarehouseLeftToReceiveItemsComponent } from './modal-edit-warehouse-left-to-receive-items/modal-edit-warehouse-left-to-receive-items.component';
import { ModalWarehouseTransferSourceDetailsComponent } from './modal-warehouse-transfer-source-details/modal-warehouse-transfer-source-details.component';
import { ModalEditProjectRequestCartQuantityComponent } from './modal-edit-project-request-cart-quantity/modal-edit-project-request-cart-quantity.component';
import { ModalProductLogReassignStock } from './modal-product-log-reassign-stock/modal-product-log-reassign-stock.component';
import { ModalProductLogExtractValueComponent } from './modal-product-log-extract-value/modal-product-log-extract-value.component';
import { ModalProductLogResolveAvailabilityComponent } from './modal-product-log-resolve-availability/modal-product-log-resolve-availability.component';
import { ModalSetupWarehouseLocationComponent } from './modal-setup-warehouse-location/modal-setup-warehouse-location.component';
import { ModalPurchasePartialApprovalComponent } from './modal-purchase-partial-approval/modal-purchase-partial-approval.component';
import { ModalEditWarehouseLocationComponent } from './modal-edit-warehouse-location/modal-edit-warehouse-location.component';
import { ModalWarehouseMoveProductLocationComponent } from './modal-warehouse-move-product-location/modal-warehouse-move-product-location.component';
import { ModalWarehouseSelectLocationComponent } from './modal-warehouse-select-location/modal-warehouse-select-location.component';
import { ModalTransactionItemSerialsComponent } from './modal-transaction-item-serials/modal-transaction-item-serials.component';
import { ModalSerialHistoryComponent } from './modal-serial-history/modal-serial-history.component';
import { ModalSelectAddressComponent } from './modal-select-address/modal-select-address.component';
import { ModalTransactionItemPickingComponent } from './modal-transaction-item-picking/modal-transaction-item-picking.component';
import { ModalWarehouseEditSkuProductMappingComponent } from './modal-warehouse-edit-sku-product-mapping/modal-warehouse-edit-sku-product-mapping.component';
import { ModalXeroSendPOComponent } from './modal-xero-send-po/modal-xero-send-po.component';
import { ModalQBOSendPOComponent } from './modal-qbo-send-po/modal-qbo-send-po.component';
import { ModalWarehouseTransferOutDestinationChange } from './modal-warehouse-destination-change/modal-warehouse-transfer-out-destination-change.component';
import { ModalProjectDeliveredItemMakeFreeStockComponent } from './modal-project-delivered-make-free-stock/modal-project-delivered-item-make-free-stock.component';
import { ModalWarehouseEditSKUQuantityComponent } from './modal-warehouse-edit-sku-quantity/modal-warehouse-edit-sku-quantity.component';
import { ModalSelectGoodsOutSourceComponent } from './modal-select-goods-out-source/modal-select-goods-out-source.component';
import { ModalViewPaymentStagesComponent } from './modal-view-payment-stages/modal-view-payment-stages.component';
import { ModalEditUpdatesLinkComponent } from './modal-edit-updates-link/modal-edit-updates-link.component';
import { ModalProjectExportAllOptionsComponent } from './modal-project-export-all-options/modal-project-export-all-options.component';
import { ModalCustomerMergeComponent } from './modal-customer-merge/modal-customer-merge.component';
import { ModalListProjectsComponent } from './modal-list-projects/modal-list-projects.component';
import { ModalSelectWarehouseForProjectTransferComponent } from './modal-select-warehouse-for-project-transfer/modal-select-warehouse-for-project-transfer.component';
import { ModalProjectDeliveredAllocateFreeStockComponent } from './modal-project-delivered-allocate-free-stock/modal-project-delivered-allocate-free-stock.component';
import { ModalProjectDeliveredBringBackComponent } from './modal-project-delivered-bring-back/modal-project-delivered-bring-back.component';
import { ModalAddSerialNumbersComponent } from './modal-add-serial-numbers/modal-add-serial-numbers.component';
import { ModalEditOrganisationFeaturesComponent } from './modal-edit-organisation-features/modal-edit-organisation-features.component';
import { ModalMoveSerialNumberLocationComponent } from './modal-move-serial-number-location/modal-move-serial-number-location.component';
import { ModalLinkScannerToOrganisationComponent } from './modal-link-scanner-to-organisation/modal-link-scanner-to-organisation.component';
import { ModalEditScannerModelComponent } from './modal-edit-scanner-model/modal-edit-scanner-model.component';
import { ModalAssignScannerModelComponent } from './modal-assign-scanner-model/modal-assign-scanner-model.component';
import { ModalScannerAddAppVersionComponent } from './modal-scanner-add-app-version/modal-scanner-add-app-version.component';
import { ModalScannerAppVersionsListComponent } from './modal-scanner-app-versions-list/modal-scanner-app-versions-list.component';
import { ModalScannerToBeUpdatedListComponent } from './modal-scanner-to-be-updated-list/modal-scanner-to-be-updated-list.component';
import { ModalReplaceLabourComponent } from './modal-replace-labour/modal-replace-labour.component';
import { ModalProductBulkEditComponent } from './modal-product-bulk-edit/modal-product-bulk-edit.component';
import { ModalAssignScannerWarehousesComponent } from './modal-assign-scanner-warehouses/modal-assign-scanner-warehouses.component';
import { ModalWarehouseResolveSkuIssuesComponent } from './modal-warehouse-resolve-sku-issues/modal-warehouse-resolve-sku-issues.component';
import { ModalWarehousePrintLabelsComponent } from './modal-warehouse-print-labels/modal-warehouse-print-labels.component';
import { ModalManageSKUProductMappingComponent } from './modal-manage-sku-product-mapping/modal-manage-sku-product-mapping.component';
import { ModalAddNotificationBlockComponent } from './modal-add-notification-block/modal-add-notification-block.component';
import { ModalEditNotificationTriggerComponent } from './modal-edit-notification-trigger/modal-edit-notification-trigger.component';
import { ModalNotificationTriggerOverviewComponent } from './modal-notification-trigger-overview/modal-notification-trigger-overview.component';
import { ModalProjectUserRolesComponent } from './modal-project-user-roles/modal-project-user-roles.component';
import { ModalBulkProjectRolesComponent } from './modal-bulk-project-roles/modal-bulk-project-roles.component';
import { ModalNotificationHelpComponent } from './modal-notification-help/modal-notification-help.component';
import { ModalProjectProgressHelpComponent } from './modal-project-progress-help/modal-project-progress-help.component';
import { ModalWequoteManageNotificationsComponent } from './modal-wequote-manage-notifications/modal-wequote-manage-notifications.component';
import { ModalBulkEditSubtaskComponent } from './modal-bulk-edit-subtask/modal-bulk-edit-subtask.component';

import { PortalNotifyUsersComponent } from './portal-notify-users/portal-notify-users.component';
import { SendProjectPortalComponent } from './send-project-portal/send-project-portal.component';

@NgModule({
	declarations: [
		PortalNotifyUsersComponent,
		SendProjectPortalComponent,
		ModalProjectManagePortalQuotesComponent,
		ModalProjectCoverImageComponent,
		ModalQuoteSelectLinesByProductComponent,
		ModalAddCategoryFromPresetsComponent,
		ModalEditCategoryComponent,
		ModalEditCategoryGroupComponent,
		ModalEditContentComponent,
		ModalEditEntityComponent,
		ModalEditLabourComponent,
		ModalEditLabourCategoryComponent,
		ModalEditPricingStructureComponent,
		ModalEditProductTypeComponent,
		ModalEditSubscriptionComponent,
		ModalEditSubscriptionCategoryComponent,
		ModalEditUnitComponent,
		ModalSelectEntityComponent,
		ModalSelectProductComponent,
		ProductResultsComponent,
		ModalEditProjectComponent,
		ModalProjectPortalAccessComponent,
		ModalPortalPreviewComponent,
		ModalAddPortalProjectComponent,
		ModalSelectQuoteComponent,
		ModalCrmQuoteDealsComponent,
		ModalEditCustomerComponent,
		ModalEditCustomerContactComponent,
		ModalSelectCustomerComponent,
		ModalLinkSupplierToAccountsComponent,
		ModalActivityLogComponent,
		ModalEditBundleCounterComponent,
		ModalEditBundleQuestionComponent,
		ModalCloneProductComponent,
		ModalEditProductComponent,
		ModalFileImporterComponent,
		ModalCustomiseSidebarComponent,
		ModalCrmPipelineComponent,
		ModalCrmSourceContactComponent,
		CrmSourceContactPickerComponent,
		ModalCrmSourceComponent,
		CrmSourcePickerComponent,
		CrmSearchSelectComponent,
		ModalReorderCategoryGroupsComponent,
		ModalProjectExportComponent,
		ModalEditEntityDirective,
		ModalQuoteChooseProjectComponent,
		ModalEditPaymentOptionComponent,
		ModalEditPaymentStageComponent,
		ModalEditPaymentStageSetupComponent,
		ModalAddPaymentStagesComponent,
		ModalSelectPaymentOptionComponent,
		ModalEditProductCategoryComponent,
		ModalEditProductCategoryGroupComponent,
		ModalReorderProductCategoryGroupsComponent,
		ModalEditProductCounterComponent,
		ModalEditProductCounterGroupComponent,
		ModalEditSnagComponent,
		ModalSelectSnagComponent,
		ModalEditProjectTimesheetComponent,
		ModalEditContactDeliveryAddressComponent,
		ModalGlobalSearchComponent,
		ProductDetailComponent,
		ModalEditOptionLibraryComponent,
		ModalSelectIconComponent,
		ModalAlertPopupComponent,
		ModalCsvImporterComponent,
		ModalHelpFormulaComponent,
		ModalEditLabelComponent,
		ModalCrmLeadComponent,
		ModalCrmDealComponent,
		ModalCrmStageComponent,
		ModalSettingsInvoiceTermsComponent,
		ModalSalesDetailsComponent,
		ModalAlertPopupComponent,
		ModalEditTaskComponent,
		ModalTaskDetailsComponent,
		ModalEditPhaseComponent,
		ModalSelectProjectComponent,
		ModalEditProductDirective,
		ModalBillingUpgradeAccountComponent,
		ModalEditDependencyComponent,
		ModalCreateTaskMultiComponent,
		ModalWorkOrderTaskListComponent,
		ModalSelectWorkOrderComponent,
		ModalEditUserComponent,
		ModalSelectCatalogueCountryComponent,
		ModalCreateManualWorkOrderComponent,
		ModalProjectInvoiceComponent,
		ModalProjectAddToInvoiceComponent,
		ModalProjectAssignAdditionalProductsComponent,
		ModalProjectConfirmSalesOrderComponent,
		ModalProjectRemoveFromInvoiceComponent,
		ModalProjectInvoicedItemsComponent,
		ModalProjectInvoiceAllocateComponent,
		ModalEditDocumentComponent,
		ModalEditProjectNotesComponent,
		ModalContactQuotesProjectsListComponent,
		ModalProjectPasswordListComponent,
		ModalQuickbooksDesktopActionsComponent,
		ModalCreateManualWorkOrderComponent,
		ModalBulkEditTaskComponent,
		ModalCrmWinComponent,
		ModalCrmLoseComponent,
		ModalCrmDiscardComponent,
		ModalQuoteAcceptComponent,
		ModalQuoteMarkAsSentComponent,
		ModalEditCustomisableHeaderFieldComponent,
		ModalEditUserContactComponent,
		ModalTimesheetExportComponent,
		ModalTimesheetEditConflictComponent,
		ModalTimesheetApprovalsComponent,
		ModalListProjectClockedinTimeComponent,
		ModalViewDependencyComponent,
		ModalTimesheetAddEntryComponent,
		ModalSelectTaskComponent,
		ModalSelectTimezoneComponent,
		ModalListScheduleCalendarComponent,
		ModalEditScheduleCalendarComponent,
		ModalProjectInvoiceAssignmentsComponent,
		ModalEditWorkOrderComponent,
		ModalWorkOrderNotesComponent,
		ModalWorkOrderContactsComponent,
		ModalWorkOrderAssignedUsersComponent,
		ModalCustomerDocumentsComponent,
		ModalWorkOrderTimelineComponent,
		ModalWorkOrderReportsComponent,
		ModalEditReportComponent,
		ModalEditDependencyOutcomeComponent,
		ModalTaskNotesComponent,
		ModalEditTutorialCategoryComponent,
		ModalEditTaskFollowupComponent,
		ModalWorkOrderDependencyComponent,
		ModalBulkEditDependencyComponent,
		ModalGenerateDependencyReportComponent,
		ModalGenerateSnaggsReportComponent,
		ModalBulkEditSnaggComponent,
		ModalEditAllocationComponent,
		ModalWorkOrderBookingHistoryComponent,
		ModalCatalogueSyncLogComponent,
		ModalPurchaseReviewReassignRequestComponent,
		ModalPurchaseChangeRequestSourceComponent,
		ModalTrackPOComponent,
		ModalAddAdditionalProductsComponent,
		ModalProductDetailsComponent,
		ModalAddWarehouseComponent,
		ModalAddProductToPOComponent,
		ModalEditWarehouseReserveItemsComponent,
		ModalEditWarehouseAdjustQuantityComponent,
		ModalEditWarehouseReorderDetailsComponent,
		ModalEditWarehouseUnitCostComponent,
		ModalListWarehouseRequestedItemsComponent,
		ModalEditWarehouseReservedStockComponent,
		ModalEditWarehouseLeftToReceiveItemsComponent,
		ModalWarehouseTransferSourceDetailsComponent,
		ModalEditProjectRequestCartQuantityComponent,
		ModalProductLogReassignStock,
		ModalProductLogExtractValueComponent,
		ModalProductLogResolveAvailabilityComponent,
		ModalSetupWarehouseLocationComponent,
		ModalEditWarehouseLocationComponent,
		ModalPurchasePartialApprovalComponent,
		ModalWarehouseMoveProductLocationComponent,
		ModalWarehouseSelectLocationComponent,
		ModalTransactionItemSerialsComponent,
		ModalSerialHistoryComponent,
		ModalSelectAddressComponent,
		ModalTransactionItemPickingComponent,
		ModalWarehouseEditSkuProductMappingComponent,
		ModalXeroSendPOComponent,
		ModalQBOSendPOComponent,
		ModalWarehouseTransferOutDestinationChange,
		ModalProjectDeliveredItemMakeFreeStockComponent,
		ModalWarehouseEditSKUQuantityComponent,
		ModalSelectGoodsOutSourceComponent,
		ModalViewPaymentStagesComponent,
		ModalEditUpdatesLinkComponent,
		ModalProjectExportAllOptionsComponent,
		ModalCustomerMergeComponent,
		ModalListProjectsComponent,
		ModalSelectWarehouseForProjectTransferComponent,
		ModalProjectDeliveredAllocateFreeStockComponent,
		ModalProjectDeliveredBringBackComponent,
		ModalAddSerialNumbersComponent,
		ModalEditOrganisationFeaturesComponent,
		ModalMoveSerialNumberLocationComponent,
		ModalLinkScannerToOrganisationComponent,
		ModalEditScannerModelComponent,
		ModalAssignScannerModelComponent,
		ModalScannerAddAppVersionComponent,
		ModalScannerAppVersionsListComponent,
		ModalScannerToBeUpdatedListComponent,
		ModalReplaceLabourComponent,
		ModalProductBulkEditComponent,
		ModalAssignScannerWarehousesComponent,
		ModalWarehouseResolveSkuIssuesComponent,
		ModalWarehousePrintLabelsComponent,
		ModalManageSKUProductMappingComponent,
		ModalAddNotificationBlockComponent,
		ModalEditNotificationTriggerComponent,
		ModalNotificationTriggerOverviewComponent,
		ModalProjectUserRolesComponent,
		ModalBulkProjectRolesComponent,
		ModalNotificationHelpComponent,
		ModalProjectProgressHelpComponent,
		ModalWequoteManageNotificationsComponent,
		ModalBulkEditSubtaskComponent
	],
	imports: [
		CommonModule,
		FormsModule,
		SharedModule,
		UIModule,
		DragDropModule,
		EditorModule,
		MediaModule,
		NgbModule,
		TutorialModule,
		CalendarModule,
		LinkyModule,
		ColorPickerModule,
		RouterModule,
		AngularResizeEventModule,
		IntegrationModule
	],
	exports: [
		PortalNotifyUsersComponent,
		SendProjectPortalComponent,
		ModalProjectManagePortalQuotesComponent,
		ModalProjectCoverImageComponent,
		ModalQuoteSelectLinesByProductComponent,
		ModalAddCategoryFromPresetsComponent,
		ModalEditCategoryComponent,
		ModalEditCategoryGroupComponent,
		ModalEditContentComponent,
		ModalEditEntityComponent,
		ModalEditLabourComponent,
		ModalEditLabourCategoryComponent,
		ModalEditPricingStructureComponent,
		ModalEditProductTypeComponent,
		ModalEditSubscriptionComponent,
		ModalEditSubscriptionCategoryComponent,
		ModalEditUnitComponent,
		ModalSelectEntityComponent,
		ModalSelectProductComponent,
		ProductResultsComponent,
		ModalEditProjectComponent,
		ModalProjectPortalAccessComponent,
		ModalPortalPreviewComponent,
		ModalAddPortalProjectComponent,
		ModalSelectQuoteComponent,
		ModalCrmQuoteDealsComponent,
		ModalEditCustomerComponent,
		ModalEditCustomerContactComponent,
		ModalSelectCustomerComponent,
		ModalLinkSupplierToAccountsComponent,
		ModalActivityLogComponent,
		ModalEditBundleCounterComponent,
		ModalEditBundleQuestionComponent,
		ModalCloneProductComponent,
		ModalEditProductComponent,
		ModalFileImporterComponent,
		ModalCustomiseSidebarComponent,
		ModalCrmPipelineComponent,
		ModalCrmSourceContactComponent,
		CrmSourceContactPickerComponent,
		ModalCrmSourceComponent,
		CrmSourcePickerComponent,
		CrmSearchSelectComponent,
		ModalReorderCategoryGroupsComponent,
		ModalProjectExportComponent,
		ModalQuoteChooseProjectComponent,
		ModalEditPaymentOptionComponent,
		ModalEditPaymentStageComponent,
		ModalEditPaymentStageSetupComponent,
		ModalAddPaymentStagesComponent,
		ModalSelectPaymentOptionComponent,
		ModalEditProductCategoryComponent,
		ModalEditProductCategoryGroupComponent,
		ModalReorderProductCategoryGroupsComponent,
		ModalEditProductCounterComponent,
		ModalEditProductCounterGroupComponent,
		ModalEditSnagComponent,
		ModalSelectSnagComponent,
		ModalEditProjectTimesheetComponent,
		ModalGlobalSearchComponent,
		ModalEditOptionLibraryComponent,
		ModalSelectIconComponent,
		ModalAlertPopupComponent,
		ModalCsvImporterComponent,
		ModalHelpFormulaComponent,
		ModalEditLabelComponent,
		ModalCrmLeadComponent,
		ModalCrmDealComponent,
		ModalCrmStageComponent,
		ModalSettingsInvoiceTermsComponent,
		ModalSalesDetailsComponent,
		ModalEditTaskComponent,
		ModalTaskDetailsComponent,
		ModalEditPhaseComponent,
		ModalSelectProjectComponent,
		ModalBillingUpgradeAccountComponent,
		ModalEditDependencyComponent,
		ModalCreateTaskMultiComponent,
		ModalWorkOrderTaskListComponent,
		ModalSelectWorkOrderComponent,
		ModalEditUserComponent,
		ModalSelectCatalogueCountryComponent,
		ModalCreateManualWorkOrderComponent,
		ModalProjectInvoiceComponent,
		ModalProjectAddToInvoiceComponent,
		ModalProjectAssignAdditionalProductsComponent,
		ModalProjectConfirmSalesOrderComponent,
		ModalProjectRemoveFromInvoiceComponent,
		ModalProjectInvoicedItemsComponent,
		ModalProjectInvoiceAllocateComponent,
		ModalEditDocumentComponent,
		ModalEditProjectNotesComponent,
		ModalContactQuotesProjectsListComponent,
		ModalProjectPasswordListComponent,
		ModalQuickbooksDesktopActionsComponent,
		ModalCreateManualWorkOrderComponent,
		ModalBulkEditTaskComponent,
		ModalCrmWinComponent,
		ModalCrmLoseComponent,
		ModalCrmDiscardComponent,
		ModalQuoteAcceptComponent,
		ModalQuoteMarkAsSentComponent,
		ModalEditCustomisableHeaderFieldComponent,
		ModalEditUserContactComponent,
		ModalTimesheetExportComponent,
		ModalTimesheetEditConflictComponent,
		ModalTimesheetApprovalsComponent,
		ModalListProjectClockedinTimeComponent,
		ModalViewDependencyComponent,
		ModalTimesheetAddEntryComponent,
		ModalSelectTaskComponent,
		ModalSelectTimezoneComponent,
		ModalListScheduleCalendarComponent,
		ModalEditScheduleCalendarComponent,
		ModalProjectInvoiceAssignmentsComponent,
		ModalEditWorkOrderComponent,
		ModalWorkOrderContactsComponent,
		ModalWorkOrderAssignedUsersComponent,
		ModalWorkOrderNotesComponent,
		ModalCustomerDocumentsComponent,
		ModalWorkOrderTimelineComponent,
		ModalWorkOrderReportsComponent,
		ModalEditReportComponent,
		ModalEditDependencyOutcomeComponent,
		ModalTaskNotesComponent,
		ModalEditTutorialCategoryComponent,
		ModalEditTaskFollowupComponent,
		ModalWorkOrderDependencyComponent,
		ModalBulkEditDependencyComponent,
		ModalGenerateDependencyReportComponent,
		ModalGenerateSnaggsReportComponent,
		ModalBulkEditSnaggComponent,
		ModalEditAllocationComponent,
		ModalWorkOrderBookingHistoryComponent,
		ModalCatalogueSyncLogComponent,
		ModalPurchaseReviewReassignRequestComponent,
		ModalPurchaseChangeRequestSourceComponent,
		ModalTrackPOComponent,
		ModalAddAdditionalProductsComponent,
		ModalProductDetailsComponent,
		ModalAddWarehouseComponent,
		ModalAddProductToPOComponent,
		ModalEditWarehouseReserveItemsComponent,
		ModalEditWarehouseAdjustQuantityComponent,
		ModalEditWarehouseReorderDetailsComponent,
		ModalEditWarehouseUnitCostComponent,
		ModalListWarehouseRequestedItemsComponent,
		ModalEditWarehouseReservedStockComponent,
		ModalEditWarehouseLeftToReceiveItemsComponent,
		ModalWarehouseTransferSourceDetailsComponent,
		ModalEditProjectRequestCartQuantityComponent,
		ModalProductLogReassignStock,
		ModalProductLogExtractValueComponent,
		ModalProductLogResolveAvailabilityComponent,
		ModalSetupWarehouseLocationComponent,
		ModalEditWarehouseLocationComponent,
		ModalPurchasePartialApprovalComponent,
		ModalWarehouseMoveProductLocationComponent,
		ModalWarehouseSelectLocationComponent,
		ModalTransactionItemSerialsComponent,
		ModalSerialHistoryComponent,
		ModalSelectAddressComponent,
		ModalTransactionItemPickingComponent,
		ModalWarehouseEditSkuProductMappingComponent,
		ModalXeroSendPOComponent,
		ModalQBOSendPOComponent,
		ModalWarehouseTransferOutDestinationChange,
		ModalProjectDeliveredItemMakeFreeStockComponent,
		ModalWarehouseEditSKUQuantityComponent,
		ModalSelectGoodsOutSourceComponent,
		ModalViewPaymentStagesComponent,
		ModalEditUpdatesLinkComponent,
		ModalProjectExportAllOptionsComponent,
		ModalCustomerMergeComponent,
		ModalListProjectsComponent,
		ModalSelectWarehouseForProjectTransferComponent,
		ModalProjectDeliveredAllocateFreeStockComponent,
		ModalProjectDeliveredBringBackComponent,
		ModalAddSerialNumbersComponent,
		ModalEditOrganisationFeaturesComponent,
		ModalMoveSerialNumberLocationComponent,
		ModalLinkScannerToOrganisationComponent,
		ModalEditScannerModelComponent,
		ModalAssignScannerModelComponent,
		ModalScannerAddAppVersionComponent,
		ModalScannerAppVersionsListComponent,
		ModalScannerToBeUpdatedListComponent,
		ModalReplaceLabourComponent,
		ModalProductBulkEditComponent,
		ModalAssignScannerWarehousesComponent,
		ModalWarehouseResolveSkuIssuesComponent,
		ModalWarehousePrintLabelsComponent,
		ModalManageSKUProductMappingComponent,
		ModalAddNotificationBlockComponent,
		ModalEditNotificationTriggerComponent,
		ModalNotificationTriggerOverviewComponent,
		ModalProjectUserRolesComponent,
		ModalBulkProjectRolesComponent,
		ModalNotificationHelpComponent,
		ModalProjectProgressHelpComponent,
		ModalWequoteManageNotificationsComponent
	],
	providers: [
		LocalizedDatePipe,
		// Injected by modal-add-payment-stages to reuse the same filtering the template does, so the
		// footer count and the rendered list can never disagree.
		KeywordsPipe
	]
})
export class ModalModule { }
